import { PageRef } from 'providers/page-ref';

export type EditTrainingGoalPageParams = {};

export type EditTrainingGoalPageResult = {
  modified: boolean;
};

export const IEditTrainingGoalPage: PageRef<EditTrainingGoalPageParams, EditTrainingGoalPageResult> = {
  pageName: 'EditTrainingGoalPage',
} as PageRef<EditTrainingGoalPageParams, EditTrainingGoalPageResult>;
